import { MDBBtn, MDBModalFooter, MDBSpinner } from 'mdb-react-ui-kit'
import React, { forwardRef, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router';
import { createSMSGroup, getMisc } from '../../../apiclients/streamsapi_bridge';
import { t } from 'i18next';

const AddSMSGroups = forwardRef((props, ref) => {
    const navigate = useNavigate();
    const [allLocations, setAllLocations] = useState([]);
    const [billingGroupList, setBillingGroupList] = useState([]);
    //const [isloading, setIsloading] = useState(false);
    const { register, watch, handleSubmit, formState: { isDirty, errors }, setError, clearErrors, reset, setValue } = useForm({
        defaultValues: {
            name: "",
            loc_id: "",
            billing_grp: 1,
        }
    }
    );

    async function fetchData() {
        console.log(sessionStorage.getItem("admin_session"));
        const response = await getMisc(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            {
                misc: ["all_locations", "billinggroups"],
            }
        );
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const tdata = await response.json();
        if (!tdata) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        setAllLocations(
            tdata.misc.all_locations.map((item) => ({
                ...item,
                loc_id: parseInt(item.loc_id, 10), // Ensure id is a number
            }))
        );
        const defaultLocation = tdata.misc.all_locations.find(loc => loc?.default_loc);
        if (defaultLocation) {
            reset((prev) => ({
                ...prev,
                loc_id: defaultLocation.loc_id.toString(),
            }))
        }
        setBillingGroupList(
            tdata.misc.billinggroups.map((item) => ({
                ...item,
                groupid: parseInt(item.groupid, 10), // Ensure id is a number
            }))
        );
    }

    useEffect(() => {
        fetchData();
    }, []);

    const onsubmit = async (data) => {
        let updates = {};
        if (isDirty) {
            updates = {
                reqid: 94,
                siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                name: data.name,
                loc_id: data.loc_id || "",
                billing_grp: data.billing_grp ? parseInt(data.billing_grp) : 1,

            };
        }
        console.log("JSON Create SMS Group:: " + JSON.stringify(updates));
        props.setIsloading(true);
        let saverep = await createSMSGroup(updates);
        console.log(`reponse of add SMS Group :::: ${JSON.stringify(saverep)}`);
        let saverepeMsg = await saverep.json();
        console.log(`reponse of add SMS Group after:::: ${JSON.stringify(saverepeMsg)}`);
        setTimeout(() => {
            props.setIsloading(false);
        }, 2000);
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            localStorage.setItem("s_message", saverepeMsg.message);
            props.onClose();

            window.location.href = "/smsgroupslanding"
        } else {
            if (saverepeMsg.message?.errors) {
                saverepeMsg.message.errors.forEach((err) => {
                    setError(err.param_name, {
                        type: "server",
                        message: err.message,
                    });
                    const fieldElement = document.querySelector(
                        `input[name="${err.param_name}"]`
                    );
                    if (fieldElement) {
                        fieldElement.focus();

                    }
                });
            }

        }
    }

    return (
        <>
            <div className="tel-numbers ">
                <strong>SMS Group Name</strong>
            </div>
            <div className="form pt-1">
                <input
                    type="text"
                    maxLength={20}
                    {...register("name", {
                        required: "Group Name is required",
                    })}
                    className="w-100 form-control" />
                {errors.name && (
                    <p className="text-danger">{errors.name.message}</p>
                )}
            </div>
            <div className="tel-numbers mt-2">
                <strong>Select Location</strong>
            </div>
            <div className="form pt-1">
                <select
                    class="form-control form-select selectname w-100"
                    name="loc_id"
                    value={parseInt(watch("loc_id"))}
                    onChange={(e) =>
                        setValue("loc_id", e.target.value, { shouldDirty: true })
                    }
                >
                    {/* <option value="">Select Location</option> */}
                    {allLocations &&
                        allLocations.length > 0 &&
                        allLocations.map((loc) => (
                            <option value={parseInt(loc.loc_id)}>{loc.loc_name}</option>
                        ))}
                </select>
                {errors.loc_id && (
                    <p className="text-danger">{errors.loc_id.message}</p>
                )}
            </div>
            <div className="tel-numbers mt-2">
                <strong>Billing Group</strong>
            </div>
            <div className="form pt-1">
                <select
                    class="form-control form-select selectname w-100"
                    name="billing_grp"
                    value={parseInt(watch("billing_grp"))}
                    onChange={(e) => setValue("billing_grp", e.target.value, { shouldDirty: true })}
                >
                    {billingGroupList &&
                        billingGroupList.map((bgrp) => (
                            <option value={bgrp.groupid}>{bgrp.groupname}</option>
                        ))}
                </select>
                {errors.billing_grp && (
                    <p className="text-danger">{errors.billing_grp.message}</p>
                )}
            </div>

            <div style={{ display: "none" }}>
                <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
                    {t("add")}</button>
            </div>
        </>
    )
});

export default AddSMSGroups
